export default __webpack_public_path__ + "slices/main/assets/public/media/chapters-card-2@2x.1cfd15b0f1ab8eee3e2449501209cf6d.png";